import { useState } from 'react';
import axios from 'axios';
import './css/ia.css';
import CONFIG from '../../config';

const URL_API_IA = `${CONFIG.API_URL}/generar_cuestionario.php`;

function CrearCuestionarioIA({ setVerNuevoCuestionarioIA, buscaCuestionarios, buscaCuestionario, idMC }) {
    const loggeduserId = localStorage.getItem('loggedUserId');

    const [loading, setLoading] = useState(false);
    const [tituloTema, setTituloTema] = useState('');
    const [contenidoTema, setContenidoTema] = useState('');
    const [cantidadPreguntas, setCantidadPreguntas] = useState(4);
    const [errorMsg, setErrorMsg] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (loading) return;

        if (!tituloTema.trim() || !contenidoTema.trim()) {
            setErrorMsg('Por favor completa el título y el contenido del tema.');
            return;
        }

        setLoading(true);
        setErrorMsg(null);

        const data = {
            curso_id: idMC,
            user_id: loggeduserId,
            tituloTema,
            contenidoTema,
            cantidadPreguntas,
        };

        try {
            const response = await axios.post(URL_API_IA, data);
            if (response.data && response.data.success) {
                const reloadFn = buscaCuestionarios || buscaCuestionario;
                if (typeof reloadFn === 'function') {
                    reloadFn();
                }
                if (typeof setVerNuevoCuestionarioIA === 'function') {
                    setVerNuevoCuestionarioIA(false);
                }
            } else {
                const msg = response.data?.message || 'Error al generar el cuestionario con IA.';
                setErrorMsg(msg);
            }
        } catch (error) {
            console.error('Error al generar el cuestionario:', error);
            setErrorMsg('Error de conexión con el servidor al intentar generar el cuestionario.');
        } finally {
            setLoading(false);
        }
    };

    return (    
        <div className="card p-3 shadow-sm border-0 position-relative">
            <h3 className="mb-3">
                <i className="fa-solid fa-wand-magic-sparkles text-primary me-2"></i>
                Crear Cuestionario con IA
            </h3>
            
            {errorMsg && (
                <div className="alert alert-danger my-2" role="alert">
                    <i className="fa-solid fa-triangle-exclamation me-2"></i>
                    {errorMsg}
                </div>
            )}

            {/* Banner de animación de espera mientras se genera */}
            {loading && (
                <div className="alert alert-info text-center p-4 my-3 rounded-3 shadow-sm">
                    <div className="spinner-border text-info mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Procesando...</span>
                    </div>
                    <h5 className="fw-bold mb-1">Generando preguntas automáticamente...</h5>
                    <p className="text-muted small mb-0">
                        Por favor espere unos momentos sin cerrar esta ventana.
                    </p>
                </div>
            )}

            <form onSubmit={handleSubmit}>
                <fieldset disabled={loading}>
                    <div className="form-floating mb-3">
                        <input 
                            type="text" 
                            className="form-control" 
                            id="floatingInput1" 
                            placeholder="Título del Tema" 
                            value={tituloTema}
                            onChange={(e) => setTituloTema(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingInput1">Título del Tema</label>
                    </div>

                    <div className="form-floating mb-3">
                        <textarea 
                            className="form-control area_textos"  
                            id="floatingTextarea2"
                            placeholder="Contenido del Tema"
                            value={contenidoTema}
                            onChange={(e) => setContenidoTema(e.target.value)}
                            style={{ height: '140px' }}
                            required
                        ></textarea>
                        <label htmlFor="floatingTextarea2">Contenido del Tema</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input 
                            type="number" 
                            className="form-control" 
                            id="floatingInput2" 
                            placeholder="Cantidad de preguntas" 
                            min="1"
                            max="10"
                            value={cantidadPreguntas}
                            onChange={(e) => setCantidadPreguntas(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingInput2">Cantidad de Preguntas Total</label>
                    </div>
                    
                    <div className='d-flex align-items-center'>
                        <button type="submit" className='btn-laboratorio me-2' disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Generando...
                                </>
                            ) : (
                                <>
                                    <i className="fa-solid fa-brain me-1"></i> Generar con IA
                                </>
                            )}
                        </button>
                        <button 
                            type="button" 
                            className="btn-laboratorio2" 
                            onClick={() => setVerNuevoCuestionarioIA(false)}
                            disabled={loading}
                        > 
                            SALIR
                        </button>
                    </div>
                </fieldset>
            </form>
        </div>
    );
}

export default CrearCuestionarioIA;